<div class="row pt-0">
	<div class="col-12">   
		<ngx-loading [show]="loadingIndicator" ></ngx-loading>
        <h5>{{caller}} Notification Settings</h5>

        <div class="col-12" *ngIf="loadingIndicator == false">
            <form [formGroup]="frm_notifications" class="row">
                
                <!-- Notifications -->
                <div widget class="card border-0 box-shadow col-12">
                    <div class="card-header transparent border-0 text-muted">
                        <h5 class="mb-0 text-success"><i class="fa fa-lg fa-bell"></i>&nbsp;Notifications</h5>
                    </div>
                    
                    <div class="card-body pt-0 widget-body">
                        <div class="form-group">
                            <div formArrayName="notifications" class="form-inline col-12">
                                <span  class="col-md-12">
                                    <table border="1" width="100%" style="color:gray">
                                        
                                            <tr>
                                                <th width="30%" class="text-left text-gray">&nbsp;Name</th>
                                                <th width="15%" class="text-left text-gray">&nbsp;Category</th>
                                                <th width="30%" class="text-center text-gray"> <input  id="check_all_notifs_email" [checked]="check_all_notifs_email" type="checkbox" ngbTooltip="Enable All Email" (click)="checkAllEmail(frm_notifications.get('notifications')['controls'], $event, 'notifications')" [disabled]="disable_all_notifs_email">&nbsp;Enable Email Notification</th>
                                                <th width="30%" class="text-center text-gray"><input  id="check_all_notifs_sms" [checked]="check_all_notifs_sms" type="checkbox" ngbTooltip="Enable All SMS" (click)="checkAllSms(frm_notifications.get('notifications')['controls'], $event, 'notifications')" [disabled]="disable_all_notifs_sms">&nbsp;Enable SMS Notification</th>
                                            </tr>
                                        
                                        <tbody *ngFor="let notif of frm_notifications.get('notifications')['controls']; let i = index">
                                            <tr [formGroupName]="i">
                                                <td width="30%">&nbsp;&nbsp;
                                                    <span *ngIf="!checkExistence(notif.controls)" style="color:black" title="{{notif.controls.description.value}}">{{notif.controls.name.value}}</span>
                                                    <span *ngIf="checkExistence(notif.controls)" style="color:gray" title="{{notif.controls.description.value}}">{{notif.controls.name.value}}</span>
                                                    <input formControlName="name" type="hidden">
                                                </td>
                                                <td width="15%">&nbsp;&nbsp;
                                                    <span *ngIf="!checkExistence(notif.controls)" style="color:black">{{notif.controls.category_name.value}}</span>
                                                    <span *ngIf="checkExistence(notif.controls)" style="color:gray">{{notif.controls.category_name.value}}</span>
                                                    <input formControlName="category_name" type="hidden">
                                                    <input *ngIf="caller=='Customer'" formControlName="customer_id" type="hidden">    
                                                </td>
                                                <td width="30%" align="center">
                                                    <input  formControlName="is_email" type="checkbox" (click)="onNotificationCheckEmailChange(notif.controls, $event, 'notifications')" ngbTooltip="Click to enable/disable email notification">&nbsp;&nbsp;
                                                    <i class="fa fa-md fa-envelope-open-o" ngbTooltip="Click to update email attachments" *ngIf="(notif.controls.name.value != 'Invoice' && notif.controls.name.value != 'Dispatch Update' && notif.controls.name.value != 'Import CSV Booking') || notif.controls.email_attachments.value.length > 0" (click)="openAttachmentModal(notif, i)"></i>
                                                    <i *ngIf="!(notif.controls.email_attachments.value.length > 0) && (notif.controls.name.value != 'Invoice' && notif.controls.name.value != 'Dispatch Update' && notif.controls.name.value == 'Import CSV Booking')" ngbTooltip="No defined attachment for this notification">--</i>
                                                    <i *ngIf="notif.controls.name.value == 'Invoice' || notif.controls.name.value == 'Dispatch Update'" ngbTooltip="Attachment for this notification is not configurable">--</i>
                                                    <br/>
                                                    <!-- document attachments -->
                                                    <hr *ngIf="notif.controls.email_attachments.value.length > 0 && (notif.controls.name.value != 'Invoice' && notif.controls.name.value != 'Dispatch Update' && notif.controls.name.value != 'Import CSV Booking')">
                                                    <div class="pull-left" *ngFor="let edoc of notif.controls.email_attachments.value">
                                                        &nbsp;&nbsp;<span *ngIf="edoc.nar_as_attachment==true || edoc.nar_as_attachment==1|| edoc.nar_as_link==true || edoc.nar_as_link==1"><i *ngIf="edoc.nar_as_attachment==1 || edoc.nar_as_attachment==true" class="fa fa-md fa-paperclip text-warning" ngbTooltip="As Attachment">&nbsp;</i><i *ngIf="edoc.nar_as_link==1 || edoc.nar_as_link==true" class="fa fa-md fa-link text-success" ngbTooltip="As Link"></i>&nbsp;{{edoc.label}}</span>
                                                    </div>
                                                </td>
                                                <td width="25%" align="center">
                                                    <input  formControlName="is_sms" type="checkbox" (click)="onNotificationCheckSMSChange(notif.controls, $event, 'notifications')"> 
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </span>
                            </div> 
                        </div>
                    </div>
                </div>
                <div>
                    <span>&nbsp;&nbsp;</span>
                    <br/>
                </div>
                <!-- Temporarily hide attachments for further discussions of implementation -->
                <!-- Attachments -->
                <!-- <div widget class="card border-0 box-shadow col-12">
                    <div class="card-header transparent border-0 text-muted">
                        <h5 class="mb-0 text-success"><i class="fa fa-lg fa-file-text"></i>&nbsp;Documents</h5>
                    </div>
                    
                    <div class="card-body pt-0 widget-body">
                        <div class="form-group">
                            <div formArrayName="attachments" class="form-inline col-12">
                                <span  class="col-md-12">
                                    <table border="1" width="100%" style="color:gray">
                                        <thead>
                                            <tr>
                                                <th width="25%" style="color:gray;text-align: center;">Document Name</th>
                                                <th width="25%" style="color:gray;text-align: center;"><input  type="checkbox" ngbTooltip="Enable All Email" (click)="checkAllEmail(frm_notifications.get('attachments')['controls'], $event, 'attachments')" [checked]="check_all_docs_email" [disabled]="disable_all_docs_email">&nbsp; Enable Email Notification</th>
                                                <th width="25%" style="color:gray;text-align: center;"><input  type="checkbox" ngbTooltip="Enable All SMS" (click)="checkAllSms(frm_notifications.get('attachments')['controls'], $event, 'attachments')"  [checked]="check_all_docs_sms" [disabled]="disable_all_docs_sms">&nbsp; Enable SMS Notification</th>
                                            </tr>
                                        </thead>
                                        
                                        <tbody *ngFor="let doc of frm_notifications.get('attachments')['controls']; let i = index">
                                            <tr [formGroupName]="i">
                                                <td width="25%">&nbsp;&nbsp;
                                                    <span *ngIf="checkExistence(doc.controls)" style="color:gray">{{doc.controls.document_name.value}}</span>
                                                    <span *ngIf="!checkExistence(doc.controls)" style="color:black">{{doc.controls.document_name.value}}</span>
                                                    <input formControlName="document_name" type="hidden">
                                                    <input *ngIf="caller=='Customer'" formControlName="customer_id" type="hidden">
                                                </td>
                                                <td width="25%" align="center">
                                                    <input  formControlName="is_email" type="checkbox" (click)="onNotificationCheckEmailChange(doc.controls, $event, 'attachments')"> 
                                                </td>
                                                <td width="25%" align="center">
                                                    <input  formControlName="is_sms" type="checkbox" (click)="onNotificationCheckSMSChange(doc.controls, $event, 'attachments')"> 
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </span>
                            </div> 
                        </div>
                    </div>
                </div>
                 -->
                <div class="row-md-12">
                    <br/>
                    <button (click)="submitForm(frm_notifications.getRawValue())" class="btn btn-sm btn-success btn-sm mb-1" [disabled]="!frm_notifications.valid || (!frm_notifications.dirty && !frm_touched) || spinner">Save Changes</button>
                    &nbsp;<i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- START OF ATTACHMENT MODAL -->
<ng-template #modalAttachment let-close="close">
    <div class="modal-header">
        <div class="col px-0">
            <div class="row no-gutters pt-0">
                <div class="col">
                    <h5 class="modal-title">Modify Attachment for <span class="text-success">{{notification_modal}}</span></h5>
                </div>
            </div>
        </div>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body bg-gray">
        <div class="row pt-0">
            <div class="col-md-12">

                <form [formGroup]="frm_notif_email_attachments" class="row">
                    <div formArrayName="attachments" class="form-inline col-12">
                        <table width="100%" border="1" style="border-color:gray">
                            <thead>
                                <tr>
                                    <th width="50%" class="text-muted text-left">&nbsp;Document</th>
                                    <th width="25%" class="text-muted text-center">As Attachment</th>
                                    <th width="25%" class="text-muted text-center">As Link</th>
                                </tr>
                            </thead>
                            
                            <tbody *ngFor="let ea of frm_notif_email_attachments.get('attachments')['controls']; let i = index">
                                <tr [formGroupName]="i">
                                    <td width="50%">&nbsp;&nbsp;
                                        <span class="text-primary">{{ea.controls.label.value}}</span>
                                    </td>
                                    <td width="25%" align="center">
                                        <input  formControlName="nar_as_attachment" type="checkbox" [attr.disabled]="ea.as_attachment == 0? true:null"> 
                                    </td>
                                    <td width="25%" align="center">
                                        <input  formControlName="nar_as_link" type="checkbox" [attr.disabled]="ea.as_link == 0? true:null"> 
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </form>
            </div>
        </div>


    </div>
    <div class="modal-footer"><i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-primary" (click)="addAttachment(frm_notif_email_attachments.value, notif_index);">Append</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Close</button>
    </div>
</ng-template>
<!-- END OF DELETE FILE MODAL -->
